import { render, staticRenderFns } from "./ComponentSelectCommunity.vue?vue&type=template&id=6140c6e5&scoped=true&"
import script from "./ComponentSelectCommunity.vue?vue&type=script&lang=js&"
export * from "./ComponentSelectCommunity.vue?vue&type=script&lang=js&"
import style0 from "./ComponentSelectCommunity.vue?vue&type=style&index=0&id=6140c6e5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6140c6e5",
  null
  
)

export default component.exports